module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ee54d776d2cda9a3c537ac7e8f144037.svg";